export const createPrompt = ({ messages }) => {
  return [...messages]
}

export const createChunks = (text) => {
  const chunks = []
  const words = text.split(' ')
  let chunk = ''

  for (const word of words) {
    if (chunk.length + word.length + 1 <= 100) {
      chunk += (chunk ? ' ' : '') + word
    } else {
      chunks.push(chunk)
      chunk = word
    }
  }

  if (chunk) {
    chunks.push(chunk)
  }

  return chunks
}

export const formatChatResponse = (response) => {
  try {
    // Handle streaming responses
    if (response.choices?.[0]?.delta?.content) {
      return response.choices[0].delta.content
    }
    
    // Handle regular responses
    if (response.choices?.[0]?.message?.content) {
      return response.choices[0].message.content
    }

    return ''
  } catch (error) {
    console.error('Error formatting chat response:', error)
    return ''
  }
}
